import { render } from "./dataTreeDataTable.vue?vue&type=template&id=d508acb2"
import script from "./dataTreeDataTable.vue?vue&type=script&lang=js"
export * from "./dataTreeDataTable.vue?vue&type=script&lang=js"

import "./dataTreeDataTable.vue?vue&type=style&index=0&id=d508acb2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__